import React from 'react';

/**
 * Sideways loading animation component with animated bars
 */
const SidewaysLoading: React.FC = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <style>
        {`
          @keyframes cycle {
              0%, 100% { height: 12px; }
              33% { height: 4px; opacity: .6; transform: translateY(3px); }
              66% { height: 8px; opacity: .8; transform: translateY(2px); }
          }
          #lines {
              transform-box: border-box;
              transform-origin: center;
              transition: transform .3s cubic-bezier(.55,-0.2,0,1.15);
          }
          #lines rect {
              width: 2px;
              transform-box: border-box;
              transform-origin: center;
              animation: cycle .6s ease infinite;
          }
          #lines rect:nth-of-type(1) { animation-delay: .2s; }
          #lines rect:nth-of-type(2) { animation-delay: .4s; }
          #lines rect:nth-of-type(3) { animation-delay: .6s; }
          #lines.done {
              transform: rotate(90deg);
          }
          #lines.done rect {
              animation: none;
          }
          #lines.done rect:nth-of-type(1) { opacity: .6; transform: translate(1px, 3px) }
          #lines.done rect:nth-of-type(2) { opacity: .8; transform: translate(1px, 2px) }
          #lines.done rect:nth-of-type(3) { opacity: 1; transform: translate(1px, 1px) }
        `}
      </style>
      <g id='lines'>
        <rect y='1' x='10' width='2' height='6' rx='1' fill='currentColor' />
        <rect y='1' x='6' width='2' height='8' rx='1' fill='currentColor' />
        <rect y='1' x='2' width='2' height='10' rx='1' fill='currentColor' />
      </g>
    </svg>
  );
};

export default SidewaysLoading;
